// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1kLlA","subheader":"ReorderModal_subheader__3IiRy","listWrap":"ReorderModal_listWrap__1JO4L"};